import { ValidatingInput, InputComponentProps } from '~/components/validating-input';
import { VALIDATE_PROMO_CODE } from '~/providers/query-params/handlers/handle-promo-code/handle-promo-code.queries';

export const PromoCode = (props: InputComponentProps) => {
  const validate = async ({ apollo, value }) => {
    if (!value.length) return true;

    const { data } = await apollo.query({
      fetchPolicy: 'no-cache',
      query: VALIDATE_PROMO_CODE,
      variables: { promoCode: value },
      context: {
        debounceKey: 'promocode-input-validation',
        debounceTimeout: 750,
      },
    });

    if (!data.validation.promoCode.isValid) return 'Please enter a valid promo code';
    return true;
  };

  return (
    <ValidatingInput
      label="Promo code"
      name="promoCode"
      placeholder="abcdef"
      validate={validate}
      {...props}
    />
  );
};
